import DVRControls from './dvr_controls'
export default DVRControls



// WEBPACK FOOTER //
// ./src/plugins/dvr_controls/index.js